import * as React from 'react';
import { css } from '@emotion/core';
import { blue, green } from '~/theseus/styles/core';

import Button from '~/theseus/components/Button';

import { Form } from '~/api/models/leadads/form';

const formSelectedStyles = css`
  position: relative;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  #form-chosen-descriptor {
    width: 100%;
    margin-bottom: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 2px solid #00000019;
  }

  #selected-form-name {
    display: inline-block;
    margin-bottom: 20px;
    padding: 10px 20px;
    font-size: 18px;
    font-weight: 500;
    color: ${blue};
    border: 1px solid ${green}80;
    border-radius: 4px;
    background: #fff;
  }

  #configured-descriptor {
    position: absolute;
    padding: 10px;
    right: 20px;
    bottom: 0;
    color: #5cac40;
    font-size: 14px;
    font-weight: 500;
    background: #fff;
    border: 1px solid #00000033;
    border-bottom: 0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

interface Props {
  formId: string;
  onReset: () => void;
  forms: Form[];
}

const SelectedForm: React.FC<Props> = (props) => {
  const {
    formId,
    onReset,
    forms,
  } = props;

  const selectedForm = React.useMemo(() => forms.find(form => form.id === formId), [forms, formId]);

  return (
    <div css={formSelectedStyles}>
      <span id="form-chosen-descriptor" aria-hidden>Selected Lead Ads Form</span>
      <div id="selected-form-name">{ selectedForm?.name }</div>
      <span id="configured-descriptor">{'\u2714 Lead Form Configured: Continue to the next step'}</span>
      <Button variant="primary" onClick={onReset}>
        Choose a different form
      </Button>
    </div>
  );
};

export default SelectedForm;
